import "lazysizes"
require("prismjs/themes/prism-tomorrow.css")